import React from 'react';

import { Skeleton } from '@/components/shadcn/ui/skeleton';
import { TableBody, TableCell, TableRow } from '@/components/shadcn/ui/table';

const SwapTableBodySkeleton: React.FC<{ count?: number }> = ({ count = 5 }) => {
  return (
    <TableBody className="[&_tr]:border-muted-foreground/20">
      {Array.from({ length: count }).map((_, index) => {
        return (
          <TableRow key={'history-table-skeleton-'.concat(String(index))} className="h-9">
            <TableCell className="w-8">
              <Skeleton className="m-1 h-5" variant="background" />
            </TableCell>
            <TableCell className="w-16">
              <Skeleton className="m-1 h-7" variant="background" />
            </TableCell>
            <TableCell className="w-20">
              <Skeleton className="m-1 h-7" variant="background" />
            </TableCell>
            <TableCell className="w-20">
              <Skeleton className="m-1 h-7" variant="background" />
            </TableCell>
            <TableCell className="w-20">
              <Skeleton className="m-1 h-5" variant="background" />
            </TableCell>
            <TableCell className="w-14">
              <Skeleton className="m-1 h-5" variant="background" />
            </TableCell>
            <TableCell className="w-14">
              <Skeleton className="m-1 h-5" variant="background" />
            </TableCell>
            <TableCell className="w-14">
              <Skeleton className="m-1 h-5" variant="background" />
            </TableCell>
            <TableCell className="w-20">
              <Skeleton className="m-1 h-5" variant="background" />
            </TableCell>
            <TableCell className="w-24">
              <Skeleton className="m-1 h-5" variant="background" />
            </TableCell>
            <TableCell className="w-14">
              <Skeleton className="m-1 h-5" variant="background" />
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};

export default SwapTableBodySkeleton;
